<div class="kpi-export-container">
  <div class="kpi-export-header">
    <h3 class="mat-h3">Export KPI Report</h3>
    <p class="export-description">
      Select the time period and download your KPI report as a CSV file.
    </p>
  </div>

  <div class="kpi-export-content">
    <form class="form-field-full" [formGroup]="exportForm">
      <!-- Export Mode Selection -->
      <div class="row">
        <div class="form-field-container col-12">
          <label class="form-field-label">Export mode</label>
          <mat-button-toggle-group
            class="export-mode-toggle w-full"
            [value]="exportMode"
            (change)="onExportModeChange($event.value)"
            >
            <mat-button-toggle value="dateRange">Date Range</mat-button-toggle>
            <mat-button-toggle value="period">Period-based</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <!-- Date Range Mode -->
      @if (exportMode === 'dateRange') {
        <div class="row">
          <div class="form-field-container col-md-6 col-12">
            <label class="form-field-label">Start date</label>
            <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
              <input
                matInput
                [matDatepicker]="startPicker"
                formControlName="startDate"
                placeholder="MM/DD/YYYY"
                readonly
                />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
              @if (startDate?.invalid && startDate?.touched) {
                <mat-error>
                  Please select a start date
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container col-md-6 col-12">
            <label class="form-field-label">End date</label>
            <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
              <input
                matInput
                [matDatepicker]="endPicker"
                formControlName="endDate"
                placeholder="MM/DD/YYYY"
                readonly
                />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
              @if (endDate?.invalid && endDate?.touched) {
                <mat-error>
                  Please select an end date
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }

      <!-- Period Mode -->
      @if (exportMode === 'period') {
        <div class="row">
          <div class="form-field-container col-md-6 col-12">
            <label class="form-field-label">Time period</label>
            <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
              <mat-select formControlName="period" placeholder="Select period">
                @for (option of periodOptions; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
              @if (period?.invalid && period?.touched) {
                <mat-error>
                  Please select a time period
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-field-container col-md-6 col-12">
            <label class="form-field-label">Period type</label>
            <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
              <mat-select formControlName="relative" placeholder="Select period type">
                @for (option of relativeOptions; track option) {
                  <mat-option [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
              @if (relative?.invalid && relative?.touched) {
                <mat-error>
                  Please select a period type
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }
    </form>
  </div>

  <div class="kpi-export-actions">
    <div class="d-flex align-items-center justify-content-end">
      @if (isLoading) {
        <div class="d-flex align-items-center">
          <mat-progress-spinner
            class="m-r-16"
            [color]="'accent'"
            [mode]="'indeterminate'"
            [diameter]="24"
            >
          </mat-progress-spinner>
          <span class="loading-text">Preparing download...</span>
        </div>
      }
      <button
        class="action-button"
        mat-raised-button
        color="accent"
        (click)="onExport()"
        [disabled]="exportForm.invalid || isLoading"
        >
        <mat-icon>download</mat-icon>
        Download Report
      </button>
    </div>
  </div>
</div>
